export const COUNTRIES = ['MX'];

export const STATES_MAP = {
  'MX': [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Coahuila de Zaragoza',
    'Colima',
    'Chiapas',
    'Chihuahua',
    'Ciudad de México',
    'Durango',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'México',
    'Michoacán de Ocampo',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'San Luis Potosí',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz de Ignacio de la Llave',
    'Yucatán',
    'Zacatecas'
  ],
};

export const CITIES_MAP = {
  "Aguascalientes": [
    "Aguascalientes",
    "Calvillo",
    "San Francisco de los Romo",
    "Jesús María ",
    "Pabellón de Arteaga",
    "Rincón de Romos",
    "Asientos",
    "Tepezalá",
    "Cosío"
  ],
  "Baja California": [
    "Ensenada",
    "Mexicali",
    "Tecate",
    "Tijuana",
    "Playas de Rosarito",
    "Rodolfo Sánchez Taboada (Maneadero)",
    "San Felipe"
  ],
  "Baja California Sur": [
    "Ciudad Constitución",
    "La Paz",
    "Cabo San Lucas",
    "San José del Cabo",
    "Loreto",
    "Puerto Adolfo López Mateos",
    "Todos Santos",
    "Heroica Mulegé",
    "Villa Alberto Andrés Alvarado Arámburo",
    "San Ignacio",
    "Guerrero Negro",
    "Santa Rosalía"
  ],
  "Campeche": [
    "San Francisco de Campeche",
    "Ciudad del Carmen",
    "Calkini",
    "Candelaria",
    "Escárcega",
    "Sabancuy",
    "Hopelchén",
    "Champotón",
    "Hecelchakán",
    "Pomuch",
    "Bécal",
    "Tenabo"
  ],
  "Coahuila de Zaragoza": [
    "Ciudad Acuña",
    "Frontera",
    "Matamoros",
    "Monclova",
    "Parras de la Fuente",
    "Piedras Negras",
    "Sabinas",
    "Saltillo",
    "Nueva Rosita",
    "San Pedro",
    "Torreón",
    "Castaños",
    "Francisco I. Madero (Chávez)",
    "Cuatro Ciénegas de Carranza",
    "Nadadores",
    "Ramos Arizpe",
    "Nava",
    "Zaragoza",
    "San Buenaventura",
    "Ciudad Melchor Múzquiz",
    "Viesca",
    "Morelos",
    "Arteaga",
    "Allende"
  ],
  "Colima": [
    "Colima",
    "Manzanillo",
    "Tecomán",
    "Ciudad de Villa de Álvarez",
    "Ciudad de Armería"
  ],
  "Chiapas": [
    "Comitán de Domínguez",
    "San Cristóbal de las Casas",
    "Tapachula de Córdova y Ordóñez",
    "Tuxtla Gutiérrez",
    "Venustiano Carranza",
    "Jiquipilas",
    "Villaflores",
    "Las Margaritas",
    "Arriaga",
    "Palenque",
    "Ocosingo",
    "Tonalá",
    "Mapastepec",
    "Las Rosas",
    "Chiapa de Corzo",
    "Cacahoatán",
    "Ocozocoautla de Espinosa",
    "Cintalapa de Figueroa",
    "Pichucalco",
    "Puerto Madero (San Benito)",
    "Pijijiapan",
    "Reforma",
    "Huixtla",
    "Motozintla de Mendoza",
    "Acala"
  ],
  "Chihuahua": [
    "Santa Rosalía de Camargo",
    "Chihuahua",
    "Cuauhtémoc",
    "Delicias",
    "Hidalgo del Parral",
    "Juárez",
    "Nuevo Casas Grandes",
    "Madera",
    "Colonia Anáhuac",
    "Juan Aldama",
    "José Mariano Jiménez",
    "Manuel Ojinaga",
    "Bachíniva",
    "Saucillo"
  ],
  "Ciudad de México": [
    "Ciudad de México"
  ],
  "Durango": [
    "Victoria de Durango",
    "Gómez Palacio",
    "Ciudad Lerdo",
    "Santiago Papasquiaro",
    "Canatlán",
    "San Juan del Río del Centauro del Norte",
    "Peñón Blanco",
    "Francisco I. Madero",
    "Nombre de Dios",
    "Vicente Guerrero",
    "El Salto",
    "Santa María del Oro"
  ],
  "Guanajuato": [
    "Acámbaro",
    "San Miguel de Allende",
    "Celaya",
    "Cortazar",
    "Guanajuato",
    "Irapuato",
    "León de los Aldama",
    "Moroleón",
    "Salamanca",
    "San Francisco del Rincón",
    "Silao",
    "Jerécuaro",
    "Santiago Maravatío",
    "Romita",
    "Tarandacuao",
    "Huanímaro",
    "Comonfort",
    "Uriangato",
    "Pénjamo",
    "Cuerámaro",
    "Empalme Escobedo",
    "San Luis de la Paz",
    "Valle de Santiago",
    "Abasolo",
    "Rincón de Tamayo",
    "Villagrán",
    "Yuriria",
    "Apaseo el Grande",
    "Purísima de Bustos",
    "Salvatierra",
    "Marfil",
    "San José Iturbide",
    "Apaseo el Alto",
    "Ciudad Manuel Doblado",
    "Jaral del Progreso",
    "San Diego de la Unión",
    "Santa Cruz Juventino Rosas",
    "Doctor Mora",
    "Dolores Hidalgo Cuna de la Independencia Nacional"
  ],
  "Guerrero": [
    "Acapulco de Juárez",
    "Chilpancingo de los Bravo",
    "Iguala de la Independencia",
    "Taxco de Alarcón",
    "Arcelia",
    "Ayutla de los Libres",
    "Atoyac de Álvarez",
    "San Jerónimo de Juárez",
    "Ciudad Apaxtla de Castrejón",
    "Ciudad Altamirano",
    "Buenavista de Cuéllar",
    "Cutzamala de Pinzón",
    "Coyuca de Catalán",
    "Tierra Colorada",
    "Coyuca de Benítez",
    "Olinalá",
    "Marquelia",
    "Zumpango del Río",
    "San Luis de la Loma",
    "Petatlán",
    "La Unión",
    "San Luis San Pedro",
    "Teloloapan",
    "Técpan de Galeana",
    "Huitzuco",
    "Tixtla de Guerrero",
    "San Marcos",
    "Azoyú",
    "Tlapehuala",
    "San Luis Acatlán",
    "Chilapa de Álvarez",
    "Tlapa de Comonfort",
    "Cuajinicuilapa",
    "Huamuxtitlán",
    "Cruz Grande",
    "Ocotito",
    "Copala",
    "Zihuatanejo"
  ],
  "Hidalgo": [
    "Actopan",
    "Apan",
    "Pachuca de Soto",
    "Fray Bernardino de Sahagún (Ciudad Sahagún)",
    "Tula de Allende",
    "Tulancingo",
    "Zimapán",
    "Huejutla de Reyes",
    "Tlaxcoapan",
    "Tizayuca",
    "Santiago Tulantepec",
    "Ixmiquilpan",
    "Tepeji del Río de Ocampo",
    "San Miguel Vindho",
    "Tepeapulco"
  ],
  "Jalisco": [
    "Ameca",
    "Ciudad Guzmán",
    "Guadalajara",
    "Lagos de Moreno",
    "Ocotlán",
    "Puerto Vallarta",
    "San Juan de los Lagos",
    "Tepatitlán de Morelos",
    "Tlaquepaque",
    "Zapopan",
    "Tlajomulco de Zúñiga",
    "Tonalá",
    "Tuxpan",
    "Tototlán",
    "San Diego de Alejandría",
    "La Resolana",
    "Atotonilco el Alto",
    "Jalostotitlán",
    "Poncitlán",
    "Arandas",
    "Talpa de Allende",
    "Etzatlán",
    "Sayula",
    "Ahualulco de Mercado",
    "Autlán de Navarro",
    "Magdalena",
    "San Julián",
    "Cocula",
    "El Grullo",
    "San Miguel el Alto",
    "Tala",
    "La Barca",
    "Jamay",
    "Yahualica de González Gallo",
    "Colotlán",
    "Cihuatlán",
    "Zapotiltic",
    "Villa Corona",
    "Teocaltiche",
    "Tequila",
    "El Quince (San José el Quince)",
    "San José el Verde (El Verde)",
    "Jocotepec",
    "Tecalitlán",
    "Chapala",
    "Ajijic",
    "San Ignacio Cerro Gordo",
    "Zacoalco de Torres",
    "Huejuquilla el Alto",
    "Villa Hidalgo",
    "Unión de San Antonio",
    "Las Pintitas",
    "Tamazula de Gordiano",
    "Acatlán de Juárez",
    "Valle de Guadalupe",
    "El Salto",
    "Villa Purificación"
  ],
  "México": [
    "Ciudad Adolfo López Mateos",
    "Chimalhuacán",
    "Coacalco de Berriozabal",
    "Cuautitlán Izcalli",
    "Ecatepec de Morelos",
    "Huixquilucan de Degollado",
    "Los Reyes Acaquilpan (La Paz)",
    "Metepec",
    "Naucalpan de Juárez",
    "Ciudad Nezahualcóyotl",
    "Ciudad Nicolás Romero",
    "Tecámac de Felipe Villanueva",
    "Tepotzotlán",
    "Tlalnepantla de Baz",
    "Santa Maria Tultepec",
    "Tultitlán de Mariano Escobedo",
    "Cuautitlán",
    "Ixtapaluca",
    "Texcoco de Mora",
    "Toluca de Lerdo",
    "Valle de Chalco Solidaridad",
    "Tejupilco de Hidalgo",
    "Chalco de Díaz Covarrubias",
    "Amatepec",
    "Melchor Ocampo",
    "Chicoloapan de Juárez",
    "Capulhuac",
    "Juchitepec de Mariano Rivapalacio",
    "Tequixquiac",
    "Xonacatlán",
    "San Mateo Atenco",
    "Chiconcuac",
    "Almoloya de Juárez",
    "Ocoyoacac",
    "Zumpango"
  ],
  "Michoacán de Ocampo": [
    "Apatzingán de la Constitución",
    "Los Reyes de Salgado",
    "Ciudad Hidalgo",
    "Jacona de Plancarte",
    "La Piedad de Cabadas",
    "Morelia",
    "Pátzcuaro",
    "Sahuayo de Morelos",
    "Uruapan",
    "Zacapu",
    "Zamora de Hidalgo",
    "Heróica Zitácuaro",
    "Paracho de Verduzco",
    "Tangancícuaro de Arista",
    "Maravatío de Ocampo",
    "Zinapécuaro de Figueroa",
    "Puruándiro",
    "Yurécuaro",
    "Huetamo de Núñez",
    "Tacámbaro de Codallos",
    "Ciudad Lázaro Cárdenas",
    "Las Guacamayas",
    "Jiquilpan de Juárez",
    "Tuxpan",
    "Cotija de la Paz",
    "Nueva Italia de Ruiz",
    "Cuitzeo del Porvenir"
  ],
  "Morelos": [
    "Cuautla",
    "Cuernavaca",
    "Galeana",
    "Jojutla",
    "Puente de Ixtla",
    "Santa Rosa Treinta",
    "Zacatepec de Hidalgo",
    "Tlaquiltenango",
    "Temixco",
    "Jiutepec",
    "Yautepec de Zaragoza"
  ],
  "Nayarit": [
    "Santiago Ixcuintla",
    "Tepic",
    "Tuxpan",
    "Acaponeta",
    "Tecuala",
    "Compostela",
    "Francisco I. Madero (Puga)",
    "Villa Hidalgo (El Nuevo)",
    "Ruíz",
    "San Blas",
    "Ixtlán del Río",
    "Bucerías",
    "Las Varas",
    "Xalisco",
    "San Pedro Lagunillas",
    "La Peñita de Jaltemba",
    "Jala",
    "Ahuacatlán"
  ],
  "Nuevo León": [
    "Ciudad Apodaca",
    "San Pedro Garza García",
    "Ciudad General Escobedo",
    "Guadalupe",
    "Linares",
    "Montemorelos",
    "Monterrey",
    "Ciudad Sabinas Hidalgo",
    "San Nicolás de los Garza",
    "Ciudad Santa Catarina",
    "Doctor Arroyo",
    "Ciénega de Flores",
    "Hualahuises",
    "Cadereyta Jiménez",
    "Santiago",
    "El cercado",
    "Anáhuac",
    "García",
    "Ciudad Benito Juárez"
  ],
  "Oaxaca": [
    "Juchitán (Juchitán de Zaragoza)",
    "Oaxaca de Juárez",
    "Salina Cruz",
    "San Juan Bautista Tuxtepec",
    "Matías Romero Avendaño",
    "Heroica Ciudad de Huajuapan de León",
    "Loma Bonita",
    "Puerto Escondido",
    "Río Grande o Piedra Parada",
    "Santiago Suchilquitongo",
    "San Felipe Jalapa de Díaz",
    "Bahias de Huatulco",
    "Putla Villa de Guerrero",
    "Cosolapa",
    "Tlacolula de Matamoros",
    "San Pablo Villa de Mitla",
    "Natividad",
    "Teotitlán de Flores Magón",
    "Santa María Huatulco",
    "San Juan Bautista Cuicatlán",
    "Villa Sola de Vega",
    "Ocotlán de Morelos",
    "Villa de Zaachila",
    "Miahuatlán de Porfirio Díaz",
    "Unión Hidalgo",
    "El Camarón",
    "San Pedro Mixtepec Distrito 22",
    "Santa Cruz Itundujia",
    "Chahuites",
    "Heroica Ciudad de Ejutla de Crespo",
    "San Pedro Tapanatepec",
    "Vicente Camalote",
    "Villa de Tamazulápam del Progreso",
    "San Juan Bautista Lo de Soto",
    "San Juan Cacahuatepec",
    "San Pedro Totolápam",
    "San Miguel el Grande",
    "Zimatlán de Álvarez",
    "San Pablo Huitzo",
    "San Francisco Telixtlahuaca",
    "Mariscala de Juárez",
    "Santiago Pinotepa Nacional",
    "Santiago Jamiltepec",
    "San Pedro Pochutla",
    "Heroica Ciudad de Tlaxiaco",
    "San Juan Bautista Valle Nacional",
    "Lagunas",
    "Ciudad Ixtepec",
    "Santiago Juxtlahuaca",
    "San Sebastián Tecomaxtlahuaca",
    "Asunción Nochixtlán",
    "San Francisco Ixhuatán",
    "San Blas Atempa",
    "Santo Domingo Tehuantepec",
    "Cuilápam de Guerrero",
    "El Rosario",
    "Santa Lucía del Camino",
    "San Antonio de la Cal"
  ],
  "Puebla": [
    "Atlixco",
    "Izúcar de Matamoros",
    "Heroica Puebla de Zaragoza",
    "San Martín Texmelucan de Labastida",
    "Tehuacán",
    "Teziutlán",
    "San Andrés Cholula",
    "San Pedro Cholula",
    "Huauchinango",
    "Acatlán de Osorio",
    "Cuautlancingo",
    "Tepeaca",
    "Tecamachalco",
    "Zacatlán",
    "Xicotepec",
    "Ciudad Serdán",
    "Amozoc"
  ],
  "Querétaro": [
    "Santiago de Querétaro",
    "San Juan del Rio",
    "El Pueblito"
  ],
  "Quintana Roo": [
    "Cancún",
    "Cozumel",
    "Felipe Carrillo Puerto",
    "Chetumal",
    "Playa del Carmen",
    "Kantunilkín",
    "Isla Mujeres",
    "Bacalar"
  ],
  "San Luis Potosí": [
    "Ciudad Valles",
    "Ébano",
    "Matehuala",
    "Rioverde",
    "San Luis Potosí",
    "Soledad de Graciano Sánchez",
    "Charcas",
    "Salinas de Hidalgo",
    "Cárdenas",
    "Cerritos",
    "Tamuín",
    "Tamasopo",
    "Ciudad del Maíz",
    "Cedral",
    "Tierra Nueva",
    "Villa de Reyes",
    "Fracción el Refugio",
    "Tamazunchale",
    "Santa María del Río",
    "El Naranjo"
  ],
  "Sinaloa": [
    "Los Mochis",
    "Culiacán Rosales",
    "Escuinapa de Hidalgo",
    "Guasave",
    "Mazatlán",
    "Guamúchil",
    "Navolato",
    "Quilá",
    "Ahome",
    "Higuera de Zaragoza",
    "Choix",
    "Villa Unión",
    "Sinaloa de Leyva",
    "Mocorito",
    "Angostura",
    "San Blas",
    "La Cruz",
    "El Rosario",
    "Estación Naranjo",
    "Cosalá",
    "San Ignacio",
    "Topolobampo",
    "Licenciado Benito Juárez (Campo Gobierno)"
  ],
  "Sonora": [
    "San Luis Río Colorado",
    "Agua Prieta",
    "Heroica Caborca",
    "Ciudad Obregón",
    "Empalme",
    "Heroica Guaymas",
    "Hermosillo",
    "Huatabampo",
    "Navojoa",
    "Heroica Nogales",
    "Puerto Peñasco",
    "Heroica Ciudad de Cananea",
    "Sonoyta",
    "Magdalena de Kino"
  ],
  "Tabasco": [
    "Cárdenas",
    "Villahermosa",
    "Comalcalco",
    "Emiliano Zapata",
    "Jalpa de Méndez",
    "Macuspana",
    "Tenosique de Pino Suárez",
    "Teapa",
    "Paraíso",
    "Frontera",
    "Cunduacán",
    "Huimanguillo"
  ],
  "Tamaulipas": [
    "Altamira",
    "Ciudad Camargo",
    "Ciudad Madero",
    "Ciudad Mante",
    "Heroica Matamoros",
    "Nuevo Laredo",
    "Reynosa",
    "Ciudad Río Bravo",
    "San Fernando",
    "Tampico",
    "Ciudad Victoria",
    "González",
    "Jaumave",
    "Ciudad Gustavo Díaz Ordaz",
    "Estación Manuel (Úrsulo Galván)",
    "Xicoténcatl",
    "Ciudad Miguel Alemán",
    "Soto la Marina",
    "Ciudad Tula",
    "Nueva Ciudad Guerrero",
    "Valle Hermoso"
  ],
  "Tlaxcala": [
    "Apizaco",
    "Villa Vicente Guerrero",
    "Tlaxcala de Xicohténcatl",
    "Huamantla",
    "Calpulalpan",
    "Chiautempan"
  ],
  "Veracruz de Ignacio de la Llave": [
    "Acayucan",
    "Naranjos",
    "Boca del Río",
    "Coatepec",
    "Agua Dulce",
    "Coatzacoalcos",
    "Córdoba",
    "Tres Valles",
    "Jáltipan de Morelos",
    "Xalapa-Enríquez",
    "Minatitlán",
    "Orizaba",
    "Papantla de Olarte",
    "Poza Rica de Hidalgo",
    "San Andrés Tuxtla",
    "Túxpam de Rodríguez Cano",
    "Veracruz",
    "Tierra Blanca",
    "Cosamaloapan",
    "Carlos A. Carrillo",
    "Pánuco",
    "Tampico Alto",
    "Tempoal de Sánchez",
    "Tantoyuca",
    "Gutiérrez Zamora",
    "Platón Sánchez",
    "Juan Rodríguez Clara",
    "Huatusco de Chicuellar",
    "Ixtaczoquitlán",
    "Río Blanco",
    "Isla",
    "Cuitláhuac",
    "Fortín de las Flores",
    "Alvarado",
    "José Cardel",
    "Banderilla",
    "Paraje Nuevo",
    "Playa Vicente",
    "Altotonga",
    "Juan Díaz Covarrubias",
    "Cuichapa",
    "Santiago Tuxtla",
    "Huayacocotla",
    "Paso de Ovejas",
    "Catemaco",
    "Nogales",
    "Las Choapas",
    "General Miguel Alemán (Potrero Nuevo)",
    "Coatzintla",
    "Ángel R. Cabada",
    "San Rafael",
    "Tlacojalpan",
    "Cosoleacaque",
    "Lerdo de Tejada",
    "Tihuatlán",
    "Atoyac",
    "Huiloapan de Cuauhtémoc",
    "Cazones de Herrera",
    "Yecuatla",
    "Soledad de Doblado",
    "Cerro Azul",
    "Tezonapa",
    "Sihuapan",
    "El Higo",
    "Paso del Macho",
    "Tlapacoyan",
    "Álamo",
    "Martínez de la Torre",
    "Perote"
  ],
  "Yucatán": [
    "Mérida",
    "Tizimín",
    "Ticul",
    "Motul de Carrillo Puerto",
    "Valladolid",
    "Kanasín",
    "Progreso"
  ],
  "Zacatecas": [
    "Fresnillo",
    "Jerez de García Salinas",
    "Zacatecas",
    "Guadalupe",
    "Río Grande",
    "Ciudad Cuauhtémoc",
    "Ojocaliente",
    "Villa Hidalgo",
    "Villanueva",
    "Villa de Cos",
    "Nochistlán de Mejía",
    "Víctor Rosales",
    "Valparaíso",
    "Luis Moya",
    "Moyahua de Estrada",
    "Sombrerete",
    "Jalpa",
    "Loreto",
    "Juan Aldama"
  ]
};
